import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { renovacao_serie_compara_unidade } from "../../services/api";

const Fidelizacao_serie_comparativa_unidade = (props) => {

    const [dataTotal, setDataTotal] = useState([]);
    const [isloading, setIsloading] = useState(true);

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await renovacao_serie_compara_unidade(cod_unidade);
            setDataTotal(response.data);
            console.log("karl", response.data)
        } catch (error) {
            console.error(error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        switch (seg) {
            case '0-1':
                return 'Mat 1';
            case '0-2':
                return 'Mat 2';
            case '0-3':
                return 'Pré 1';
            case '0-4':
                return 'Pré 2';
            case '1-1':
                return '1º Fund I';
            case '1-2':
                return '2º Fund I';
            case '1-3':
                return '3º Fund I';
            case '1-4':
                return '4º Fund I';
            case '1-5':
                return '5º Fund I';
            case '1-6':
                return '6º Fund II';
            case '1-7':
                return '7º Fund II';
            case '1-8':
                return '8º Fund II';
            case '1-9':
                return '9º Fund II';
            case '2-1':
                return '1ª Médio';
            case '2-2':
                return '2ª Médio';
            case '2-3':
                return '3ª Médio';
            default:
                return seg;
        }
    };


    let chartDataSeg = [];
    // if (typeof dataTotal !== 'undefined') {
    if (!isloading) {
        chartDataSeg = dataTotal.map((item, index) => {
            const row = [convertSegmento(item.serie)];
            let ev27 = (parseFloat(item.evasao_27) * 100) / parseFloat(item.pr_27);
            let ev26 = (parseFloat(item.evasao_26) * 100) / parseFloat(item.pr_26);
            row.push(ev27);
            row.push(ev26);
            let seta = '';
            if (ev27 < ev26) { seta = '<i class="fa-solid fa-circle-arrow-down" style="color: green ;"></i>' } else { seta = '<i class="fa-solid fa-circle-arrow-up" style="color: red;"></i>' }
            row.push(ev27 - ev26);
            row.push(seta);
            return row;

        });
    };
    chartDataSeg.unshift(['SEGMENTO', 'EV 27', 'EV 26', 'Variação', '']);


    const options = {
        allowHtml: true,

    };
    const formatters = [

        {
            type: "NumberFormat",
            column: 1,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 26, "white", "green"],
                [26, 40, "white", "orange"],
                [40, 50, "white", "red"],
                [50, 75, "white", "darkred"],
                [75, 100, "white", "black"],
            ],
        },

        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 26, "white", "green"],
                [26, 40, "white", "orange"],
                [40, 50, "white", "red"],
                [50, 75, "white", "darkred"],
                [75, 100, "white", "black"],
            ],
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [0, 999, "white", "red"],
                [-999, 0, "white", "green"],
            ],
        },
    ];

    return (
        <div className="Evasão">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDataSeg}
                options={options}
                formatters={formatters}
            />
        </div>
    );

};

export default Fidelizacao_serie_comparativa_unidade;